import { EEnvironment } from "./app.config.types";
// Local APIs of the `local` Docker environment (own MySQL in Docker).
// The variants that run local APIs against a remote database live in
// app.config.local.dev.ts, .stag.ts, .demo.ts and .prod.ts.
export var CONFIG_LOCAL = {
    // Main
    ENVIRONMENT: EEnvironment.Dev,
    // Rentio API
    // BASE_URL_V1: "https://api.dev.rentio-internal.be/v1",
    BASE_URL_V1: "http://localhost:3100/v1",
    // BASE_URL_V2: "https://api-next.dev.rentio-internal.be/v2",
    BASE_URL_V2: "http://localhost:3000/v2",
    BASE_URL_SERVERLESS: "https://serverless.dev.rentio-internal.be",
    URL_SOCKETS: "ws://localhost:3100/v1/websocket?access_token={{accessToken}}&locale={{locale}}",
    BASE_URL_INSURANCE: "https://dev.api.rentio-insurance.be/v1",
    // BASE_URL_INSURANCE: "http://localhost:3001/v1",
    // Google
    CAPTCHA_KEY: 
    // cspell:disable-next-line
    "6LcxNJokAAAAAO7A3tB4AGgq8GI-_4TXjjy0Bpuy",
    // Rentio
    RENTIO_BROKER_ID: 1000,
    // Partners
    INSURANCE_TENANT_FLOW_URL: "https://dev.rentio-insurance.be",
    KEYPOINT_REPAIR_URL: "https://uat-case.keypoint.be",
};
